import { hideFeaturedCampaignPopup } from "@app/store/app/appActions"
import { RootState } from "@app/types"
import React from "react"
import { useDispatch, useSelector } from "react-redux"

// Components
import Popup, { PopupButtons, PopupContent, PopupTitle } from "@modules/popup/Popup"
import Button from "@ng-mw/reol/components/Button"
import useUserStatus from "@ng-mw/shared-react-components/src/modules/user/helpers/useUserStatus"
import { getCampaignPopupTexts } from "../FeaturedCampaign"

const FeaturedCampaignPopup = () => {
    const dispatch = useDispatch<any>()
    const isOpen = useSelector((state: RootState) => state.app.featuredCampaignPopup.visible)
    const { userIsLoggedInAndLoaded, user } = useUserStatus()

    const config = getCampaignPopupTexts(userIsLoggedInAndLoaded, user)

    const handleClose = () => {
        dispatch(hideFeaturedCampaignPopup())
    }

    return config ? (
        <Popup
            onClose={handleClose}
            isOpen={isOpen}
            isHeaderActionsOverflow={true}
        >
            {config.image ? (
                <img
                    className="top-banner-popup__image"
                    src={config.image.url}
                    aria-hidden="true"
                    alt={config.image.alt}
                />
            ) : (
                <img
                    className="top-banner-popup__image"
                    src="/images/mlh-bud-foran-bil.jpg"
                    aria-hidden="true"
                    alt="Budbilsjåfør bærer pappeske full av matvarer, stående foran en stor varebil med Meny-logo"
                />
            )}

            <PopupTitle>{config.title}</PopupTitle>
            <PopupContent>{config.description}</PopupContent>
            <PopupButtons isSimple>
                <Button
                    onClick={handleClose}
                    isSecondary
                >
                    Fortsett å handle
                </Button>
            </PopupButtons>
        </Popup>
    ) : null
}

export default FeaturedCampaignPopup
